module.exports = __webpack_public_path__ + "static/media/tile_business.e4e5b35e.svg";